import { render, staticRenderFns } from "./AdvProductGallery.vue?vue&type=template&id=20d3b6b8&scoped=true"
import script from "./AdvProductGallery.vue?vue&type=script&lang=js"
export * from "./AdvProductGallery.vue?vue&type=script&lang=js"
import style0 from "./AdvProductGallery.vue?vue&type=style&index=0&id=20d3b6b8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20d3b6b8",
  null
  
)

export default component.exports